var _defs, _polygon, _polygon2, _line, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew308({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "12.66 5.23 7.97 2.52 7.97 7.94 12.66 5.23"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.19 5.23 2.5 2.52 2.5 7.94 7.19 5.23"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.5,
    y1: 1.76,
    x2: 13.5,
    y2: 8.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.5,12.93V9.87H4.61a1.15,1.15,0,0,1,.52.09.67.67,0,0,1,.27.28,1,1,0,0,1,.11.47.86.86,0,0,1-.18.56.87.87,0,0,1-.53.27,1,1,0,0,1,.21.17,2,2,0,0,1,.26.39l.44.83H5.29L5,12.3c-.13-.25-.23-.42-.29-.51a.7.7,0,0,0-.19-.17.63.63,0,0,0-.26,0H3.83v1.36Zm.33-1.71h.72a.84.84,0,0,0,.35-.05A.41.41,0,0,0,5.09,11a.51.51,0,0,0,.07-.28A.49.49,0,0,0,5,10.34a.61.61,0,0,0-.41-.13H3.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6,12.93V9.87H7a1.5,1.5,0,0,1,.49.06.62.62,0,0,1,.34.3.93.93,0,0,1,.13.52,1.06,1.06,0,0,1-.21.68.9.9,0,0,1-.73.26H6.36v1.24Zm.33-1.6H7a.64.64,0,0,0,.45-.14.57.57,0,0,0,.14-.42.62.62,0,0,0-.07-.31.37.37,0,0,0-.17-.18.91.91,0,0,0-.36,0H6.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.17,12.93v-.37l1.29-2a2.68,2.68,0,0,1,.26-.37H8.32V9.87h1.79v.36l-1.4,2.13-.16.21h1.61v.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.5,12.93V9.87h.87a1.54,1.54,0,0,1,.49.06.89.89,0,0,1,.38.27,1.5,1.5,0,0,1,.25.49,2.38,2.38,0,0,1,.09.7,2.13,2.13,0,0,1-.16.88,1.05,1.05,0,0,1-.39.51,1.14,1.14,0,0,1-.62.15Zm.33-.36h.54a.94.94,0,0,0,.49-.1.71.71,0,0,0,.26-.34,2.37,2.37,0,0,0,.11-.75,1.82,1.82,0,0,0-.12-.73.69.69,0,0,0-.33-.36,1.1,1.1,0,0,0-.42-.06h-.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew308);
export default __webpack_public_path__ + "static/media/Symbolpack_New_308.de6a1f3914044cfb656995482e04751d.svg";
export { ForwardRef as ReactComponent };